import isLightOS from './isLightOS'
import { ICallback } from './interface'

/**
 * 当 H5 页面完全展示之前需要和 native 先进行交互，此用来控制时序。只有 App 调用了 ready(deviceready,hsAppReady) 方法后，表示 App 端已经准备完毕，已注入了相关 js 对象。防止 App 还没注入 js 对象方法，H5 过早调用 App 提供的方法
 * 兼容 lightOS 离线包及 tzyj 在线
 *
 * @param {ICallback} { success, complete }
 */
function nativeReadySync({ success, complete }: ICallback) {
  if (isLightOS()) {
    document.addEventListener('deviceready', () => {
      success && success()
    })
  } else {
    document.addEventListener('hsAppReady', () => {
      success && success()
    })
  }
  complete && complete()
}

/**
 * 当 H5 页面完全展示之前需要和 native 先进行交互，此用来控制时序。只有 App 调用了 ready(deviceready,hsAppReady) 方法后，表示 App 端已经准备完毕，已注入了相关 js 对象。防止 App 还没注入 js 对象方法，H5 过早调用 App 提供的方法
 * 兼容 lightOS 离线包及 tzyj 在线
 * 一个异步接口，支持 Promise 化使用
 * @returns
 */
function nativeReady() {
  return new Promise((resolve, reject) => {
    if (isLightOS()) {
      document.addEventListener('deviceready', () => {
        resolve()
      })
    } else {
      document.addEventListener('hsAppReady', () => {
        resolve()
      })
    }
  })
}

export { nativeReady, nativeReadySync }
